var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79051 7.675L4.25601 6.7V13.9045C4.25595 13.9828 4.27134 14.0603 4.3013 14.1327C4.33127 14.205 4.37522 14.2708 4.43064 14.3261C4.48605 14.3814 4.55184 14.4252 4.62424 14.4551C4.69663 14.4849 4.77421 14.5002 4.85251 14.5H14.4025C14.4809 14.5003 14.5586 14.4852 14.6311 14.4554C14.7036 14.4256 14.7695 14.3818 14.825 14.3264C14.8806 14.2711 14.9246 14.2053 14.9546 14.1329C14.9847 14.0605 15.0001 13.9829 15 13.9045V11.25L9.79051 7.675Z",
    fill: "#185C37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79051 1.5H4.85251C4.77421 1.4998 4.69663 1.51507 4.62424 1.54491C4.55184 1.57475 4.48605 1.6186 4.43064 1.67392C4.37522 1.72924 4.33127 1.79496 4.3013 1.8673C4.27134 1.93965 4.25595 2.0172 4.25601 2.0955V4.75L9.79051 8L12.721 8.975L15 8V4.75L9.79051 1.5Z",
    fill: "#21A366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25601 4.75H9.79051V8H4.25601V4.75Z",
    fill: "#107C41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.21701 4.1H4.25601V12.225H8.21701C8.37484 12.2242 8.52601 12.1613 8.63776 12.0498C8.74951 11.9383 8.81283 11.7873 8.81401 11.6295V4.6955C8.81283 4.53767 8.74951 4.38666 8.63776 4.27519C8.52601 4.16373 8.37484 4.10078 8.21701 4.1Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.89151 4.425H4.25601V12.55H7.89151C8.04934 12.5492 8.20051 12.4863 8.31226 12.3748C8.42401 12.2633 8.48733 12.1123 8.48851 11.9545V5.0205C8.48733 4.86267 8.42401 4.71166 8.31226 4.6002C8.20051 4.48873 8.04934 4.42579 7.89151 4.425Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.89151 4.425H4.25601V11.9H7.89151C8.04934 11.8992 8.20051 11.8363 8.31226 11.7248C8.42401 11.6133 8.48733 11.4623 8.48851 11.3045V5.0205C8.48733 4.86267 8.42401 4.71166 8.31226 4.6002C8.20051 4.48873 8.04934 4.42579 7.89151 4.425Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.56601 4.425H4.25601V11.9H7.56601C7.72384 11.8992 7.87501 11.8363 7.98676 11.7248C8.09851 11.6133 8.16183 11.4623 8.16301 11.3045V5.0205C8.16183 4.86267 8.09851 4.71166 7.98676 4.6002C7.87501 4.48873 7.72384 4.42579 7.56601 4.425Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.597 4.425H7.566C7.72412 4.42487 7.87581 4.48752 7.98776 4.59918C8.0997 4.71084 8.16274 4.86238 8.163 5.0205V10.9795C8.16274 11.1376 8.0997 11.2892 7.98776 11.4008C7.87581 11.5125 7.72412 11.5751 7.566 11.575H1.597C1.51865 11.5753 1.44103 11.56 1.36857 11.5302C1.29612 11.5004 1.23027 11.4566 1.1748 11.4013C1.11933 11.3459 1.07534 11.2802 1.04534 11.2078C1.01534 11.1354 0.999934 11.0578 1 10.9795V5.0205C0.999934 4.94215 1.01534 4.86456 1.04534 4.79219C1.07534 4.71981 1.11933 4.65407 1.1748 4.59874C1.23027 4.54341 1.29612 4.49958 1.36857 4.46976C1.44103 4.43995 1.51865 4.42474 1.597 4.425Z",
    fill: "url(#paint0_linear_4_2)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85001 9.9365L4.10551 7.9945L2.95551 6.0635H3.87901L4.50651 7.3C4.56451 7.417 4.60651 7.504 4.62551 7.562H4.63401C4.67501 7.46833 4.71834 7.37733 4.76401 7.289L5.43501 6.0655H6.28501L5.10551 7.9855L6.31501 9.938H5.41051L4.68551 8.5825C4.65194 8.52417 4.62334 8.46312 4.60001 8.4H4.58801C4.56682 8.46152 4.53863 8.52041 4.50401 8.5755L3.75751 9.9365H2.85001Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14.403 1.5H9.7905V4.75H15V2.0955C15.0001 2.01716 14.9847 1.93957 14.9547 1.86719C14.9247 1.79481 14.8807 1.72907 14.8252 1.67374C14.7697 1.61841 14.7039 1.57458 14.6314 1.54477C14.559 1.51495 14.4813 1.49974 14.403 1.5Z",
    fill: "#33C481"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7905 8H15V11.25H9.7905V8Z",
    fill: "#107C41"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_2",
    x1: 2.247,
    y1: 3.957,
    x2: 6.916,
    y2: 12.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.6392be1f4cb130fb707e6b73267136df.svg";
export { ForwardRef as ReactComponent };